import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectMoldReleaseData = state => selectState(state).data;
export const selectMoldReceivingData = state => selectState(state).data;
export const selectMoldReleaseLoading = state => selectState(state).loading;
export const selectfetchMoldReleaseLoading = state => selectState(state).releaseLoading;
export const selectMoldReleaseError = state => selectState(state).error;
export const selectMoldReleaseFilterVisible = state => selectState(state).filterVisible;
export const selectMoldReceivingFilterVisible = state => selectState(state).filterVisible;
export const selectMoldReleaseFilters = state => selectState(state).filters;
export const selectMoldReceivingFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectFilteredMoldReceiving = createSelector(
  [selectMoldReceivingData, selectMoldReceivingFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);
